module.exports = __webpack_public_path__ + "static/media/heroVideo.984a86b7.mov";